import { useState, useEffect } from 'react';
import { OktaAuth } from '@okta/okta-auth-js';

const useOktaAuthConfig = (oktaConfig) => {
  const [oktaAuth, setOktaAuth] = useState(null);

  useEffect(() => {
    if (oktaConfig) {
      setOktaAuth(new OktaAuth(oktaConfig));
    }
  }, [oktaConfig]);

  return oktaAuth;
};

export default useOktaAuthConfig;
